module.exports = __webpack_public_path__ + "media/icons/tapicerka-skorzana-unactive@3x-7e63e5eb.svg";